export const RECIPE_CATEGORIES = Object.freeze([
  "Торты",
  "Тарты и тарталетки",
  "Пирожные и десерты",
  "Кексы, маффины и капкейки",
  "Печенье",
  "Мелкая выпечка",
  "Шу и эклеры",
  "Рулеты",
  "Бисквиты и основы",
  "Тесто",
  "Кремы",
  "Ганаши",
  "Муссы",
  "Начинки",
  "Карамель и пралине",
  "Хрустящие слои",
  "Пропитки",
  "Глазури и покрытия",
  "Декор",
  "Другое",
]);

const CATEGORY_RULES = Object.freeze([
  [/(?:^|\s)(?:капкейк|маффин|кекс)/iu, "Кексы, маффины и капкейки"],
  [/(?:тарталет|(?:^|\s)тарт(?:\s|$))/iu, "Тарты и тарталетки"],
  [/(?:торт|тортик)/iu, "Торты"],
  [/(?:пирожн|десерт)/iu, "Пирожные и десерты"],
  [/(?:печень|cookie)/iu, "Печенье"],
  [/(?:булоч|бриош|круассан|слойк|ватруш|пирожок)/iu, "Мелкая выпечка"],
  [/(?:эклер|профитрол|\bшу\b)/iu, "Шу и эклеры"],
  [/(?:рулет)/iu, "Рулеты"],
  [/(?:бисквит|корж|основа)/iu, "Бисквиты и основы"],
  [/(?:^|\s)тест[оа](?:\s|$)/iu, "Тесто"],
  [/(?:ганаш)/iu, "Ганаши"],
  [/(?:мусс)/iu, "Муссы"],
  [/(?:начинк|конфи|компоте|курд)/iu, "Начинки"],
  [/(?:карамел|пралине)/iu, "Карамель и пралине"],
  [/(?:кранч|хрустящ)/iu, "Хрустящие слои"],
  [/(?:пропит|сироп для пропит)/iu, "Пропитки"],
  [/(?:глазур|покрыти|велюр)/iu, "Глазури и покрытия"],
  [/(?:декор|украшени)/iu, "Декор"],
  [/(?:крем)/iu, "Кремы"],
]);

// Deliberately conservative: only an explicit product word in the recipe
// title selects a category. Ingredients and fuzzy similarity never do.
export function suggestRecipeCategory(title) {
  const normalized = String(title || "").trim().toLocaleLowerCase("ru");
  if (!normalized) return "Другое";
  return CATEGORY_RULES.find(([pattern]) => pattern.test(normalized))?.[1] || "Другое";
}

export function recipeCategoryOrFallback(category) {
  return RECIPE_CATEGORIES.includes(category) ? category : "Другое";
}

// "Другое" is a safe storage fallback, not a reason to ignore an explicit
// product word in the title. This is applied only when a recipe is reviewed
// or saved; it does not migrate existing records in the background.
export function categoryForRecipeSave(title, category) {
  const canonical = recipeCategoryOrFallback(category);
  return canonical === "Другое" ? suggestRecipeCategory(title) : canonical;
}
